import { render } from "./ParticipantsPage.vue?vue&type=template&id=1c529dc6&scoped=true"
import script from "./ParticipantsPage.vue?vue&type=script&lang=js"
export * from "./ParticipantsPage.vue?vue&type=script&lang=js"

import "./ParticipantsPage.vue?vue&type=style&index=0&id=1c529dc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c529dc6"]])

export default __exports__